function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/jsx-props-no-spreading */

import { useFormWithDetachedSubmitButton } from '@deephaven/react-hooks';
import { SpectrumButton, ButtonGroup, Content, Dialog, Divider, Form, Heading } from "../spectrum/index.js";
import styles from "../SpectrumComponent.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ConfirmationDialog(_ref) {
  var heading = _ref.heading,
    confirmationButtonLabel = _ref.confirmationButtonLabel,
    children = _ref.children,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm;
  var _useFormWithDetachedS = useFormWithDetachedSubmitButton(),
    formProps = _useFormWithDetachedS.formProps,
    submitButtonProps = _useFormWithDetachedS.submitButtonProps;
  return /*#__PURE__*/_jsxs(Dialog, {
    children: [/*#__PURE__*/_jsx(Heading, {
      level: 3,
      UNSAFE_className: styles.spectrumDialogComponentHeading,
      children: heading
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Content, {
      children: /*#__PURE__*/_jsx(Form
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread(_objectSpread({}, formProps), {}, {
        children: children
      }))
    }), /*#__PURE__*/_jsxs(ButtonGroup, {
      children: [/*#__PURE__*/_jsx(SpectrumButton, {
        variant: "secondary",
        onPress: onCancel,
        children: "Cancel"
      }), /*#__PURE__*/_jsx(SpectrumButton, _objectSpread(_objectSpread({}, submitButtonProps), {}, {
        // eslint-disable-next-line react/style-prop-object
        style: "fill",
        variant: "negative",
        onPress: onConfirm,
        type: "submit",
        children: confirmationButtonLabel
      }))]
    })]
  });
}
export default ConfirmationDialog;
//# sourceMappingURL=ConfirmationDialog.js.map